export const apiGetRequest = async (
  url: string,
  page: number = -1,
  filters: any = {}
) => {
  const finalUrl = buildQuery(url, page, filters);

  const response = await $fetch(finalUrl, {
    method: 'GET',
    headers: getHeaders(),
  });

  return response;
};

export const apiPostRequest = async (url: string, data: any) => {
  try {
    const response = await $fetch(url, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    return { success: response, error: null };
  } catch (error: any) {
    return { success: null, error: error };
  }
};

export const apiPutRequest = async (
  url: string,
  data: any,
  page: number = -1,
  filters: any = {}
) => {
  try {
    const finalUrl = buildQuery(url, page, filters);

    const response = await $fetch(finalUrl, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    return { success: response, error: null };
  } catch (error) {
    return { success: null, error: error };
  }
};

export const apiDeleteRequest = async (
  url: string,
  page: number = -1,
  filters: any = {}
) => {
  try {
    const finalUrl = buildQuery(url, page, filters);

    const response = await $fetch(finalUrl, {
      method: 'DELETE',
      headers: getHeaders(),
    });

    return { success: response, error: null };
  } catch (error) {
    return { success: null, error: error };
  }
};

// Function to generate authorization headers
/*
 DUPLICATE CODE useBackend.ts is used
export function getHeaders() {
  const authCookie = useCookie<{ access: string; refresh: string }>('jwtToken');
  return {
    Authorization: `Bearer ${authCookie.value ? authCookie.value.access : ''}`,
  };
}
  */

// Utility function to build the query string with pagination and filters
const buildQuery = (url: string, page: number = -1, filters: any = {}) => {
  // Convert the filters object into a query string
  const filterQuery = Object.entries(filters)
    .map(([key, value]: [string, any]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const hasQueryOneQuestionMark = (testUrl: string) =>
    testUrl.includes('?') ? '&' : '?';

  // Append the filter query string to the URL
  if (filterQuery) {
    url += `${hasQueryOneQuestionMark(url)}${filterQuery}`;
  }

  // Append the page number to the URL
  if (page > 0) {
    url += `${hasQueryOneQuestionMark(url)}page=${page}`;
  }

  return url;
};
